import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InpatMedicineTrackerComponent } from './inpat-medicine-tracker.component';

@NgModule({
    imports:[MatDialogModule,CommonModule,MatCheckboxModule,MatInputModule ,MatSelectModule,MatFormFieldModule,MatIconModule,MatButtonModule,FormsModule],
    declarations:[InpatMedicineTrackerComponent],
    exports:[InpatMedicineTrackerComponent]
})
export class InpatMedicineTrackerModule{   
   
}